import React from 'react';
import { Link, Route } from 'react-router-dom'
import Be from '../../icons/components/be.js'
import './description.css';
import FlechaAbajo from '../../icons/components/flechaAbajo.js'


class descriptionProject extends React.Component {

  constructor(props){
    super(props)
    this.state={
      bajo:4
    }
  }

  adicionarUno(){
    try{
      this.setState({bajo:1});
      console.log(this.state.bajo);
    }catch(error){
      console.log(error)
    }
  }
  adicionarDos(){
    try{
      this.setState({bajo:2});
      console.log(this.state.bajo);
    }catch(error){
      console.log(error)
    }
  }
  adicionarTres(){
    try{
      this.setState({bajo:3});
      console.log(this.state.bajo);
    }catch(error){
      console.log(error)
    }
  }
  adicionarFinal(){
    try{
      this.setState({bajo:4});
      console.log(this.state.bajo);
    }catch(error){
      console.log(error)
    }
  }

  aparece(){
    if (this.state.bajo == 1) {
      return  <p>When the brand first began to be built, sketches were made, in which all the possibilities of analogies with the world of the engine were explored. A very interesting shape was explored inside a turbo. The turbine has a fast and bold shape, it was modified until it took the shape we wanted.</p>
    } else if (this.state.bajo == 2) {
      return  <p>When the logo was finished we started making different pieces for the brand, such as flyers, evacuation plans, notebooks, business cards, etc. With each challenge that was placed we obtained and improved extra shapes that could be combined with the brand.</p>
    } else if (this.state.bajo == 3) {
      return  <p>In the last move, we started designing the landing page. First we started with wireframes to explore the possibilities and then we saw reference in Behance, Dribbble or even Pinterest. Having a few diagrams ready, the UI was relatively easy, since it had all the data and writing required.</p>
    } else if (this.state.bajo == 4) {
      return  <p>"La casa del turbo ltda is a Colombian company created to satisfy the growing demand for services and spare parts in diesel injection systems and turbochargers. With 15 years of experience in the market we are able to provide the best service to our distinguished clientele". </p>
    }
  }

  render() {
    return (
      <div className='descripcionProjecto'>
        <section className="flechaUp">
          <Link to='/projectsMonucks' >
        <figure className="flechaArriba">
        <FlechaAbajo size={23} color="white" />
        </figure>
        </Link>
        </section>
        <div className='tituloProjecto '>
          <h2 className='estiloFuente'>La casa del turbo ltda</h2>
          <div className='estiloFuente'>
            <h3>Branding</h3>
            <h3 className='fecha'>2017</h3>
          </div>
        </div>
        <div className='pasosProceso '>
          <div className='estiloFuente'><h2>Process Step</h2></div>

          <div className='estiloFuente'>
            <div className='numberStep'  onClick={this.adicionarUno.bind(this)} >  1 </div>
            <div className='numberStep' onClick={this.adicionarDos.bind(this)}>  2   </div>
            <div className='numberStep' onClick={this.adicionarTres.bind(this)}>  3   </div>
            <div className='numberStep' onClick={this.adicionarFinal.bind(this)}>  Final </div>
          </div>

          <div className='hijoTresTres'>

            {this.aparece()}
          </div>
        </div>
        <div className='hijoTresCuatro '>
          <div className='estiloFuente'><h3>Repositorio o url del proyecto:</h3></div>
          <div className='estiloFuente'>
              <a  href="https://www.behance.net/julianstiv775f" >
            <figure className="be">
              <Be size={30} color="white" />
            </figure>
          </a>
          </div>
        </div>
      </div>
    )}
  }

  export default descriptionProject;



// WEBPACK FOOTER //
// ./src/projects/Empfehlung/description.js